__turbopack_context__.v({
  "close": "sheet-module__tPNg0G__close",
  "closeIcon": "sheet-module__tPNg0G__closeIcon",
  "content": "sheet-module__tPNg0G__content",
  "description": "sheet-module__tPNg0G__description",
  "footer": "sheet-module__tPNg0G__footer",
  "header": "sheet-module__tPNg0G__header",
  "overlay": "sheet-module__tPNg0G__overlay",
  "sheet-overlay-in": "sheet-module__tPNg0G__sheet-overlay-in",
  "sheet-overlay-out": "sheet-module__tPNg0G__sheet-overlay-out",
  "sheet-slide-in-bottom": "sheet-module__tPNg0G__sheet-slide-in-bottom",
  "sheet-slide-in-left": "sheet-module__tPNg0G__sheet-slide-in-left",
  "sheet-slide-in-right": "sheet-module__tPNg0G__sheet-slide-in-right",
  "sheet-slide-in-top": "sheet-module__tPNg0G__sheet-slide-in-top",
  "sheet-slide-out-bottom": "sheet-module__tPNg0G__sheet-slide-out-bottom",
  "sheet-slide-out-left": "sheet-module__tPNg0G__sheet-slide-out-left",
  "sheet-slide-out-right": "sheet-module__tPNg0G__sheet-slide-out-right",
  "sheet-slide-out-top": "sheet-module__tPNg0G__sheet-slide-out-top",
  "side-bottom": "sheet-module__tPNg0G__side-bottom",
  "side-left": "sheet-module__tPNg0G__side-left",
  "side-right": "sheet-module__tPNg0G__side-right",
  "side-top": "sheet-module__tPNg0G__side-top",
  "srOnly": "sheet-module__tPNg0G__srOnly",
  "title": "sheet-module__tPNg0G__title",
});
